export const messages = {
  en: {
    community: {
      addCommunity: 'Add Community',
      page: {
        title: 'Community Overview',
        subtitle: 'Browse the list of communities and their service periods',
        listTitle: 'Community List',
        empty: 'No community records found',
        tip: 'Select the region filters to narrow down the community list',
        selectProvince: 'Please select a province',
        selectCity: 'Please select a city',
        selectDistrict: 'Please select a district'
      },
      province: 'Province',
      city: 'City',
      district: 'District',
      communityName: 'Community Name',
      communityCode: 'Community Code',
      phone: 'Phone',
      area: 'Area(㎡)',
      startTime: 'Start Time',
      endTime: 'End Time',
      status: 'Status'
    }
  },
  zh: {
    community: {
      addCommunity: '添加小区',
      page: {
        title: '小区总览',
        subtitle: '查看小区列表及其服务周期',
        listTitle: '小区列表',
        empty: '暂无小区记录',
        tip: '选择省市区筛选条件可缩小小区范围',
        selectProvince: '请选择省份',
        selectCity: '请选择城市',
        selectDistrict: '请选择区/县'
      },
      province: '省份',
      city: '市/州',
      district: '区/县',
      communityName: '小区名称',
      communityCode: '小区编码',
      phone: '联系电话',
      area: '面积(㎡)',
      startTime: '开始时间',
      endTime: '结束时间',
      status: '状态'
    }
  }
} 